import React from 'react';
import {
  FiCode, FiSmartphone, FiBookOpen, FiTrendingUp, FiGlobe, FiLayers,
  FiShoppingBag, FiCoffee, FiHeart, FiHome, FiBriefcase,
  FiMonitor, FiEdit3, FiCompass, FiFilm, FiAward, FiSmile, FiBook
} from 'react-icons/fi';

// Maps content keys from src/data/site.js to a single outline icon set.
const icons = {
  code: FiCode,
  smartphone: FiSmartphone,
  book: FiBookOpen,
  trending: FiTrendingUp,
  globe: FiGlobe,
  layers: FiLayers,
  monitor: FiMonitor,
  edit: FiEdit3,
  compass: FiCompass,
  film: FiFilm,
  award: FiAward,
  smile: FiSmile,
  library: FiBook,
  school: FiBookOpen,
  shop: FiShoppingBag,
  food: FiCoffee,
  health: FiHeart,
  property: FiHome,
  corporate: FiBriefcase
};

const Icon = ({ name, ...props }) => {
  const Component = icons[name] || FiLayers;
  return <Component aria-hidden="true" {...props} />;
};

export default Icon;
